<script lang="ts">
  type Faq = {
    slug: string;
    summary: string;
    content: string;
  };
  const faqs: Faq[] = [
    {
      slug: "public-link",
      summary: "How can I get a public link to my file?",
      content:
        "Some algorithms might use a public URL for a parameter. Currently Dropbox or Google Drive offer simple ways to share files publicly. (For Dropbox, you will need to change the final '0' of the URL to a '1', to make sure it downloads). ",
    },
    // {
    //   slug: "geojson",
    //   summary: "What is a GeoJSON file?",
    //   content: "Google it",
    // },
  ];
</script>

<div class="is-size-3 block">Frequently asked questions</div>
{#each faqs as { slug, summary, content }}
  <!-- svelte-ignore a11y-missing-content -->
  <a id={slug} />
  <details>
    <summary>{summary}</summary>
    <p>{content}</p>
  </details>
{/each}
